import {
  submitCaseFailure,
  submitCaseSuccess,
  OFLC_SUBMIT_CASE
} from "../actions";
import { ofType } from "redux-observable";
import { mergeMap } from "rxjs/operators";

import util from "../../../global/utils/Helpers";
import "isomorphic-fetch";
import { polyfill } from "es6-promise";
polyfill();

let apiIndex = util.isLocalhost()
  ? "http://localhost:9393/auth/visa/submit/"
  : `${util.getCurrentHost()}/auth/auth/visa/submit/`;

const fetchSubmitCase = action$ =>
  action$.pipe(
    ofType(OFLC_SUBMIT_CASE),
    mergeMap(action =>
      fetch(apiIndex + action.payload.form_id, {
        credentials: "include",
        method: "POST",
        body: JSON.stringify(action.payload),
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Basic " +
            window.btoa("flagdevteam1:account-standard-xxxxx44xx3xxxxxxxxxxxx1")
        }
      })
        .then(response => {
          if(!response.ok){
            throw new Error();
          }
          return response.json()
        })
        .then(data => {
          if (!data) { let data = {}; data.error = ""; }
          if (
            data.statusCode === 500 ||
            data.statusCode === 502 ||
            data.statusCode === 503 ||
            data.statusCode === 429 ||
            data.statusCode === 400 ||
            data.error
          ) {
            return submitCaseFailure(data.error);
          } else {
            return submitCaseSuccess();
          }
        })
        .catch(error => {
          return submitCaseFailure();
        })
    )
  );

export default fetchSubmitCase;
